import React from 'react'
import Latex from 'react-latex-next';
// redux
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import Formulario from './Formulario';

const Ejercicios = () => {

  const { ejercicios, isLoading } = useSelector((state: RootState) => state.ejercicio);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <>
      {
        ejercicios.map((item, index) => {

          const { eid, tipo, enunciado, respuesta, estado, alternativas } = item;

          return (
            <div className='card mb-4' key={eid}>
              <div className="card-header">
                {estado === true && <i className="fa-regular fa-circle-check" style={{color: 'green'}} />}
                {estado === false && <i className="fa-regular fa-circle-xmark" aria-hidden="true" style={{color: 'red'}} />}
                {estado === undefined && <i className="fa-regular fa-circle" />}
                <span style={{fontSize: '1.1em', marginLeft: '7px'}}>Ejercicio {index+1}</span>
              </div>
              <div className="card-body">
                <Latex>{enunciado}</Latex>
              </div>

              <Formulario
                eid={eid}
                tipo={tipo}
                respuesta={respuesta}
                alternativas={alternativas}
              />
            </div>
          )
        })
      }
    </>
  )
}

export default Ejercicios

// import { useSelector } from 'react-redux';
// import { RootState } from '../../store';
// import FormularioAntiderivada from './Formularios/FormularioAntiderivada';
// // componentes propios
// import FormularioEcuacion from './Formularios/FormularioEcuacion';
// import FormularioFormula from './Formularios/FormularioFormula';
// import FormularioIntervalo from './Formularios/FormularioIntervalo';
// import FormularioNumero from './Formularios/FormularioNumero';
// import FormularioPunto from './Formularios/FormularioPunto';
// import FormularioSM from './Formularios/FormularioSM';
// import FormularioVector from './Formularios/FormularioVector';

// const Ejercicios = () => {

//   const { ejercicios, isLoading } = useSelector((state: RootState) => state.ejercicio);

//   if (isLoading) {
//     return (
//       <div className="d-flex justify-content-center">
//         <div className="spinner-border text-success" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     )
//   }

//   return (
//     <>
//       {
//         ejercicios.map((item, index) => {
//           const { eid, tipo, variable, numero, enunciado, respuesta, estado, alternativas } = item;
//           if (tipo === 'numerico') {
//             return (
//               <FormularioNumero
//                 key={eid}
//                 eid={eid}
//                 tipo={tipo}
//                 variable={variable}
//                 numero={numero}
//                 enunciado={enunciado}
//                 respuesta={respuesta}
//                 estado={estado}
//                 index={index}
//               />
//             )
//           }

//           if (tipo === 'intervalo') {
//             return (
//               <FormularioIntervalo
//                 key={eid}
//                 eid={eid}
//                 tipo={tipo}
//                 variable={variable}
//                 numero={numero}
//                 enunciado={enunciado}
//                 respuesta={respuesta}
//                 estado={estado}
//                 index={index}
//               />
//             )
//           }

//           if (tipo === 'formula') {
//             return (
//               <FormularioFormula
//                 key={eid}
//                 eid={eid}
//                 tipo={tipo}
//                 variable={variable}
//                 numero={numero}
//                 enunciado={enunciado}
//                 respuesta={respuesta}
//                 estado={estado}
//                 index={index}
//               />
//             )
//           }

//           if (tipo === 'ecuacionXY') {
//             return (
//               <FormularioEcuacion
//                 key={eid}
//                 eid={eid}
//                 tipo={tipo}
//                 variable={variable}
//                 numero={numero}
//                 enunciado={enunciado}
//                 respuesta={respuesta}
//                 estado={estado}
//                 index={index}
//               />
//             )
//           }

//           if (tipo === 'punto') {
//             return (
//               <FormularioPunto
//                 key={eid}
//                 eid={eid}
//                 tipo={tipo}
//                 variable={variable}
//                 numero={numero}
//                 enunciado={enunciado}
//                 respuesta={respuesta}
//                 estado={estado}
//                 index={index}
//               />
//             )
//           }

//           if (tipo === 'vector') {
//             return (
//               <FormularioVector
//                 key={eid}
//                 eid={eid}
//                 tipo={tipo}
//                 variable={variable}
//                 numero={numero}
//                 enunciado={enunciado}
//                 respuesta={respuesta}
//                 estado={estado}
//                 index={index}
//               />
//             )
//           }

//           if (tipo === 'antiderivada') {
//             return (
//               <FormularioAntiderivada
//                 key={eid}
//                 eid={eid}
//                 tipo={tipo}
//                 variable={variable}
//                 numero={numero}
//                 enunciado={enunciado}
//                 respuesta={respuesta}
//                 estado={estado}
//                 index={index}
//               />
//             )
//           }

//           if (tipo === 'seleccion-multiple') {
//             return (
//               <FormularioSM
//                 key={eid}
//                 eid={eid}
//                 tipo={tipo}
//                 variable={variable}
//                 numero={numero}
//                 enunciado={enunciado}
//                 alternativas={alternativas}
//                 estado={estado}
//                 index={index}
//               />
//             )
//           }
          

//           return (
//             <div key={eid}>PENDIENTE</div>
//           )
//         })
//       }
//     </>
//   )
// }

// export default Ejercicios;